// Mixins
import AppPage from '../../mixins/app-page'

// Components
import AppButtonBook from '../app-button-book'
import AppScrollObject from '../app-scroll-object'

// Utils
import { getSafe } from '../../utils/Object'
import getAbsoluteBoundingRect from '../../utils/getAbsoluteBoundingRect'

export default
{
    name: 'page-restaurant',

    mixins:
    [
        AppPage
    ],

    components:
    {
        AppButtonBook,
        AppScrollObject
    },

    data()
    {
        return {
            numberOfImagesOnScreen: 0,
            galleryWrapperWidth: 0,
            galleryActiveIndex: 0,
            galleryActiveIndexMax: 0,
            widthOfAnImageInGallery: 0
        }
    },

    computed:
    {
        content()
        {
            return this.$root.contentPage.page.acf
        },

        restaurant()
        {
            if (!getSafe(() => this.$root.contentPage.restaurant)) return null

            return this.$root._populateRestaurant(this.$root.contentPage.restaurant.acf)
        },

        blocksOfContent()
        {
            const blocks = []

            if (getSafe(() => this.restaurant.content_blocks)
                && this.restaurant.content_blocks.length > 0)
            {
                for (let i = 0; i < this.restaurant.content_blocks.length; i += 1)
                {
                    const block = this.restaurant.content_blocks[i]

                    if (block)
                    {
                        if (block.type === this.$root.CONSTANTS.restaurantBlocksTypes.I_T)
                        {
                            block.captions = []
                            const items = []

                            if (getSafe(() => block.images)
                                && block.images.length > 0)
                            {
                                for (let j = 0; j < block.images.length; j += 1)
                                {
                                    const image = block.images[j]

                                    if (image.caption.trim() !== '')
                                    {
                                        block.captions.push(image.caption)
                                    }

                                    image.image.caption = image.caption

                                    items.push(image.image)
                                }
                            }

                            if (items.length <= 2)
                            {
                                items.push(block.captions)
                            }
                            else
                            {
                                items.splice(items.length - 1, 0, block.captions)
                            }

                            delete block.captions
                            delete block.images

                            block.items = items
                        }

                        blocks.push(block)
                    }
                }
            }

            return blocks
        }
    },

    watch:
    {
        restaurant: 'onRestaurantChange'
    },

    created()
    {
        if (!this.restaurant)
        {
            this.$root.changePage(this.$root.getPageURLFromName('notFound'))
        }

        // Events
        this.eventHub.$on('window:resize', this._onResize)
        this.eventHub.$on('window:raf', this._onEnterFrame)
        this.eventHub.$on('application:scroll-enabled', this._onResize)
        this.eventHub.$on('keyboard:keydown', this._onKeydown)

        console.log('page-restaurant', this.restaurant)

        // Variables
        this.fixedButtonIsHidden = true

        this._headerBookButtonRect = null
        this._footerBookButtonRect = null
        this._galleryWrapperRect = null
        this._galleryWrapperIsVisible = false

        this.PIXEL_STEP = 10
        this.LINE_HEIGHT = 40
        this.PAGE_HEIGHT = 800

        this._pointer =
        {
            isDown: false,
            x: 0,
            y: 0,
            start:
            {
                x: 0,
                y: 0
            }
        }
    },

    mounted()
    {
        // Events
        this.eventHub.$emit('page:medias-loaded')
        this.eventHub.$emit('restaurat:booking',
            {
                theForkId: this.restaurant.the_fork_restaurant_id,
                label: this.restaurant.booking_book_a_table
            }
        )

        // Elements
        if (this.$el)
        {
            this.$headerBookButton = this.$el.querySelector('.js-header-book-button')
            this.$footerBookButton = this.$el.querySelector('.js-footer-book-button')
            this.$galleryWrapper = this.$el.querySelector('.js-gallery-wrapper')
        }
    },

    destroyed()
    {
        // Events
        this.eventHub.$on('window:resize', this._onResize)
        this.eventHub.$off('window:raf', this._onEnterFrame)
        this.eventHub.$off('application:scroll-enabled', this._onResize)
        this.eventHub.$off('keyboard:keydown', this._onKeydown)
    },

    methods:
    {
        // Watchers
        onRestaurantChange()
        {
            this.$nextTick(() =>
            {
                this.eventHub.$emit('page:medias-loaded')
                this.eventHub.$emit('page:ready', this.ready)
            })
        },

        // Events
        _onResize()
        {
            this.$nextTick(() =>
            {
                if (this.$headerBookButton)
                {
                    this._headerBookButtonRect = getAbsoluteBoundingRect(this.$headerBookButton)
                }

                if (this.$footerBookButton)
                {
                    this._footerBookButtonRect = getAbsoluteBoundingRect(this.$footerBookButton)
                }

                if (getSafe(() => this.restaurant.gallery_images)
                    && this.restaurant.gallery_images.length > 0
                    && this.$galleryWrapper)
                {
                    this.numberOfImagesOnScreen = this.$root.width <= this.$root.CONSTANTS.breakpoints.sm ? 2 : 4
                    const spaceBetweenImages = this.$root.width / 10 * 1
                    this.widthOfAnImageInGallery = (this.$root.width - (spaceBetweenImages * (this.numberOfImagesOnScreen - 1))) / this.numberOfImagesOnScreen

                    this.galleryWrapperWidth = (this.widthOfAnImageInGallery * this.restaurant.gallery_images.length) + (spaceBetweenImages * (this.restaurant.gallery_images.length - 1))

                    this.galleryActiveIndexMax = Math.ceil(this.restaurant.gallery_images.length / this.numberOfImagesOnScreen)

                    this.galleryActiveIndex = 0
                    this._moveGalleryWrapper()

                    this._galleryWrapperRect = getAbsoluteBoundingRect(this.$galleryWrapper)
                }
            })
        },

        _onEnterFrame()
        {
            if (this._headerBookButtonRect
                && this._footerBookButtonRect
                && this.$root.width > this.$root.CONSTANTS.breakpoints.xxs)
            {
                if (this.$root.smoothScroll > this._headerBookButtonRect.top + this._headerBookButtonRect.height
                    && this.$root.smoothScroll < this._footerBookButtonRect.top - this.$root.height)
                {
                    if (this.fixedButtonIsHidden)
                    {
                        this.fixedButtonIsHidden = false
                        this.eventHub.$emit('app-fixed-button-book:show')
                    }
                }
                else if (!this.fixedButtonIsHidden)
                {
                    this.fixedButtonIsHidden = true
                    this.eventHub.$emit('app-fixed-button-book:hide')
                }
            }

            if (this._galleryWrapperRect
                && this.$root.width > this.$root.CONSTANTS.breakpoints.xxs)
            {
                if (this.$root.smoothScroll + this.$root.height >= this._galleryWrapperRect.top
                    && this.$root.smoothScroll <= this._galleryWrapperRect.top + this._galleryWrapperRect.height)
                {
                    if (!this._galleryWrapperIsVisible)
                    {
                        this._galleryWrapperIsVisible = true
                    }
                }
                else if (this._galleryWrapperIsVisible)
                    {
                    this._galleryWrapperIsVisible = false
                }
            }
        },

        _onGalleryTouchstart(event)
        {
            this._pointer.isDown = true

            this._pointer.start.x = event.touches[0].clientX
            this._pointer.start.y = event.touches[0].clientY

            this._pointer.x = this._pointer.start.x
            this._pointer.y = this._pointer.start.y
        },

        _onGalleryTouchmove(event)
        {
            if (!this._pointer.isDown)
            {
                return
            }

            event.preventDefault()

            this._pointer.x = event.touches[0].clientX
            this._pointer.y = event.touches[0].clientY
        },

        _onGalleryTouchend(event)
        {
            if (!this._pointer.isDown)
            {
                return
            }

            this._pointer.isDown = false

            const xDif = this._pointer.start.x - this._pointer.x

            if (Math.abs(xDif) > 10)
            {
                if (xDif < 0)
                {
                    this._onClickGalleryPrevious()
                }
                else
                {
                    this._onClickGalleryNext()
                }
            }
        },

        _onKeydown(event)
        {
            if (event
                && this._galleryWrapperIsVisible)
            {
                if (event.keyCode === 37)
                {
                    this._onClickGalleryPrevious()
                }
                else if (event.keyCode === 39)
                {
                    this._onClickGalleryNext()
                }
            }
        },

        // HTML Actions
        _onClickGalleryPrevious()
        {
            if (this.galleryActiveIndex > 0)
            {
                this.galleryActiveIndex -= 1

                this._moveGalleryWrapper()
            }
        },

        _onClickGalleryNext()
        {
            if (this.galleryActiveIndex < this.galleryActiveIndexMax - 1)
            {
                this.galleryActiveIndex += 1

                this._moveGalleryWrapper()
            }
        },

        _moveGalleryWrapper()
        {
            if (this.$galleryWrapper)
            {
                const translateX = this.galleryActiveIndex > 0 ? (this.galleryActiveIndex * (100 + 10)) * -1 : (this.galleryActiveIndex * 100) * -1

                this.$galleryWrapper.style.transform = `translateX(${translateX}vw) translateZ(0)`
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/page-restaurant/script.js